import './App.css'
import SmartInfo from './components/SmartInfo'
import Button1 from './components/Button1'
import ClickBuy from './components/ClickBuy'


function App() {

  return (
    <div className="App">
      <h1 className="App-pad">whiteWhale</h1>
        <pre>
{`    # @version ^0.2.0
    # @title    whiteWhale
    # @author   ZERO_ARTIST

    owner       :   public(address)
    pricePaid   :   public(uint256)

    @external
    @payable

    def buyMe():

        assert self.pricePaid * 2   <=   msg.value
        self.pricePaid               =   msg.value

        send( self.owner , self.balance )

        self.owner   =   msg.sender
`}
          </pre>
      <Button1 onClick={ClickBuy}>buyMe</Button1>
      <SmartInfo />

      <a href="https://explorer.harmony.one/address/0x082138b691c47773a8d2ffee453f665184959a53">
      <h3>contract@: one1pqsn3d53c3mh82xjllhy20mx2xzftxjnckyjts</h3>
      </a>

      <a href="https://github.com/ZERO-ARTIST">
      <img className='App-logoCtr' src="./GitHub-Mark-Light-32px.png" alt='GitHub'/>
      </a>
      <div className="App-pad"></div>




    </div>
  )
}

export default App;
